import { render, staticRenderFns } from "./ViewCertificate.vue?vue&type=template&id=cc7d834c&scoped=true&"
import script from "./ViewCertificate.vue?vue&type=script&lang=js&"
export * from "./ViewCertificate.vue?vue&type=script&lang=js&"
import style0 from "./ViewCertificate.vue?vue&type=style&index=0&id=cc7d834c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7d834c",
  null
  
)

export default component.exports